import React from 'react';
import styled from 'styled-components';
import { Poppins } from 'src/common/Poppins';
import { DataThreeSvg } from 'src/assets/dynamicSvg';

const Card = styled.div<{ $bare?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 308px;
  padding: 20px;
  background: ${({ theme }) => theme.colors.cultured};
  border: 1px solid ${({ theme }) => theme.colors.stroke};
  border-radius: 8px;

  ${({ $bare }) =>
    $bare &&
    `
    border: none;
    border-radius: 0;
  `}
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  max-width: 410px;
`;

export const EmptyStateCard: React.FC<{ bare?: boolean }> = ({ bare }) => (
  <Card $bare={bare}>
    <Col>
      <DataThreeSvg size={64} />
      <Poppins px={16} weight={600} color="cflowerBlue">
        Your suggested risk scenario shows up here
      </Poppins>
      <Poppins px={16} color="cflowerBlue" css="line-height: 1.7;">
        Type in or edit description above and click analyse to get suggestions populated here.
      </Poppins>
    </Col>
  </Card>
);
